import React from 'react';
import { BadgeVariant } from '../../constants/ui';

interface SummaryCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const getVariantClasses = (variant: BadgeVariant): string => {

  
  switch (variant) {
    case 'emerald':
      return `bg-gradient-to-br from-emerald-50 to-emerald-100 dark:from-emerald-900/20 dark:to-emerald-800/20 border-emerald-200 dark:border-emerald-800`;
    case 'amber':
      return `bg-gradient-to-br from-amber-50 to-amber-100 dark:from-amber-900/20 dark:to-amber-800/20 border-amber-200 dark:border-amber-800`;
    case 'slate':
    default:
      return `bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-800 dark:to-slate-900 border-slate-200 dark:border-slate-700`;
  }
};

const getIconBgClasses = (variant: BadgeVariant): string => {
  switch (variant) {
    case 'emerald':
      return 'bg-emerald-200 dark:bg-emerald-800/50';
    case 'amber':
      return 'bg-amber-200 dark:bg-amber-800/50';
    case 'slate':
    default:
      return 'bg-slate-200 dark:bg-slate-700';
  }
};

const getTitleClasses = (variant: BadgeVariant): string => {
  switch (variant) {
    case 'emerald':
      return 'text-emerald-700 dark:text-emerald-400';
    case 'amber':
      return 'text-amber-700 dark:text-amber-400';
    case 'slate':
    default:
      return 'text-slate-600 dark:text-slate-400';
  }
};

const getValueClasses = (variant: BadgeVariant): string => {
  switch (variant) {
    case 'emerald':
      return 'text-emerald-900 dark:text-white';
    case 'amber':
      return 'text-amber-900 dark:text-white';
    case 'slate':
    default:
      return 'text-slate-900 dark:text-white';
  }
};

const getIconClasses = (variant: BadgeVariant): string => {
  switch (variant) {
    case 'emerald':
      return 'text-emerald-600 dark:text-emerald-400';
    case 'amber':
      return 'text-amber-600 dark:text-amber-400';
    case 'slate':
    default:
      return 'text-slate-600 dark:text-slate-400';
  }
};

export const SummaryCard: React.FC<SummaryCardProps> = React.memo(({
  title,
  value,
  icon,
  variant = 'slate',
  className = ''
}) => {
  return (
    <div className={`p-2.5 rounded-lg border ${getVariantClasses(variant)} ${className}`}>
      <div className="flex items-center justify-between">
        <div>
          <h3 className={`text-xs font-medium ${getTitleClasses(variant)}`}>
            {title}
          </h3>
          <p className={`text-lg font-bold mt-0.5 ${getValueClasses(variant)}`}>
            {value}
          </p>
        </div>
        <div className={`w-8 h-8 rounded-md flex items-center justify-center ${getIconBgClasses(variant)}`}>
          <div className={`w-4 h-4 ${getIconClasses(variant)}`}>
            {icon}
          </div>
        </div>
      </div>
    </div>
  );
});
SummaryCard.displayName = 'SummaryCard';

export default SummaryCard;